module.exports = __webpack_public_path__ + "img/9788959372300.d0ec4a44.jpg";